<div class="page gray-font-color font-family">
    <div class="header-navigation-back" >
      <div class="back-icon" (click)="backAction()" data-test="back-arrow-icon">
        <mat-icon svgIcon="left-arrow" data-testid="back-arrow-icon"></mat-icon>
      </div>
      <span class="title">{{ getTitle(title) }}</span>
      @if (isContentReady && form?.get('file')?.value?.id) {
        <button
          mat-button
          class="header-action-button header-action-button-primary save-btn"
          [disabled]="form.invalid || isExtracting || isSaving"
          [class.save-disabled]="form.invalid || isExtracting || isSaving"
          (click)="saveDocument()"
          data-testid="header-save-btn">
          @if (isSaving) {
            <mat-spinner diameter="16" class="save-spinner"></mat-spinner>
          } @else {
            Save
          }
        </button>
      }
    </div>
    <div class="content" [ngClass]="{ 'hide-content': !isContentReady }">
        <app-upload-document
        [formUploadFiles]="formUploadFiles"
        [documentDqfStatus]="true"
        [hideTabs]="true"
        (uploadDocument)="uploadDocument()"
        (saveDocument)="saveDocument()"
        (clearFile)="onFileClear()"
        [documentType]="documentType"
        [isExtracting]="isExtracting"
        [isSaving]="isSaving"
        [extractionFailed]="extractionFailed"
        [extractionWarning]="extractionWarning"
        ></app-upload-document>
    </div>
 </div>